export default {
  // Ported from aqua-web-app — used by the account Licenses views
  // (Breadcrumbs variant="aqua_account"); without it the separator icon
  // renders unsized (fullscreen chevron).
  snap_account: {
    container: "bg-paper/70 w-fit rounded-2xl px-4 py-0 mb-6",
    list: "flex items-center space-x-2 text-sm",
    item: "flex items-center",
    itemContent: "flex items-center space-x-2",
    link: "flex items-center text-neutral_3 hover:text-primary transition-colors cursor-pointer",
    text: "flex items-center text-neutral_3",
    current: "flex items-center text-primary font-medium",
    icon: "w-4 h-4 mr-1 flex-shrink-0",
    separator: "flex items-center text-neutral_3 mx-2",
    separatorIcon: "w-4 h-4",
  },
}
